//#region DevExtreme Imports

import 'devextreme/ui/drop_down_box'

//#endregion

import { ChangeStatusScope, ChangeStatusController } from "./change-status.directive.controller"

//#region Asset Imports

import * as TEMPLATE from './change-status.tpl.html'

//#endregion

export class ChangeStatusDirective implements ng.IDirective {

    controller = ['$scope', ($scope: ChangeStatusScope) => new ChangeStatusController($scope)]

    restrict = 'E'

    scope = {
        id: '=',
        options: '=?'
    }

    template = TEMPLATE
}